import React, { useState } from "react";
import PropTypes from "prop-types";
import { Typography, Box, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@material-ui/core";
import { COLORS } from "../constants";
import { Btn } from "../components/UI";
import { useStyles } from "./template-library-view.style";

export function TemplateLibraryView({
  templates,
  openNewTemplate,
  openEditTemplate,
  deleteTemplate,
  wizardStartApply,
}) {
  const classes = useStyles();
  const [templateToDelete, setTemplateToDelete] = useState(null);

  const handleDeleteConfirm = () => {
    if (templateToDelete) {
      deleteTemplate(templateToDelete.id);
      setTemplateToDelete(null);
    }
  };

  const handleCloseDialog = () => setTemplateToDelete(null);

  return (
    <Box className={classes.root}>
      <Box className={classes.header}>
        <Box>
          <Typography variant="h6" sx={{ fontWeight: 700, color: COLORS.body }}>
            Template Library
          </Typography>
          <Typography variant="body2" sx={{ color: COLORS.muted, marginTop: '6px' }}>
            Reusable configuration packages
          </Typography>
        </Box>
        <Btn size="small" onClick={openNewTemplate}>
          + New Template
        </Btn>
      </Box>
      {templates.length === 0 && (
        <Typography className={classes.emptyState}>
          No templates yet.
        </Typography>
      )}
      {templates.map((template) => (
        <Box key={template.id} className={classes.templateCard}>
          <Box className={classes.templateIcon}>
            📋
          </Box>
          <Box className={classes.templateContent}>
            <Typography className={classes.templateName}>
              {template.name}
            </Typography>
            <Typography className={classes.templateDesc}>{template.desc}</Typography>
            <Box className={classes.templateMeta}>
              <Typography component="span" variant="caption" sx={{ color: COLORS.primary }}>
                {template.services.length} service{template.services.length === 1 ? "" : "s"}
              </Typography>
              <Typography component="span" variant="caption" sx={{ color: COLORS.primary }}>
                {template.resources.length} resource{template.resources.length === 1 ? "" : "s"}
              </Typography>
              <Typography component="span" variant="caption" sx={{ color: COLORS.muted }}>
                {template.updated}
              </Typography>
            </Box>
          </Box>
          <Box className={classes.templateActions}>
            <Btn variant="text" size="small" onClick={() => setTemplateToDelete(template)} sx={{ color: COLORS.error }}>
              Delete
            </Btn>
            <Btn variant="outlined" size="small" onClick={() => openEditTemplate(template)}>
              Edit
            </Btn>
            <Btn size="small" onClick={() => wizardStartApply(template.id)}>
              Apply
            </Btn>
          </Box>
        </Box>
      ))}
      <Dialog open={Boolean(templateToDelete)} onClose={handleCloseDialog} maxWidth="xs" fullWidth>
        <DialogTitle>Delete template?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {templateToDelete && (
              <>
                Delete <strong>{templateToDelete.name}</strong>? This cannot be undone.
              </>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Btn variant="outlined" size="small" onClick={handleCloseDialog}>
            Cancel
          </Btn>
          <Btn size="small" onClick={handleDeleteConfirm} sx={{ background: COLORS.danger }}>
            Delete
          </Btn>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

TemplateLibraryView.propTypes = {
  templates: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    desc: PropTypes.string,
    services: PropTypes.array,
    resources: PropTypes.array,
    updated: PropTypes.string,
  })).isRequired,
  openNewTemplate: PropTypes.func.isRequired,
  openEditTemplate: PropTypes.func.isRequired,
  deleteTemplate: PropTypes.func.isRequired,
  wizardStartApply: PropTypes.func.isRequired,
};
